















import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import VoteButton from '../components/VoteButton.vue';
import { Icon } from 'vant';
import { getDetail } from '../api';

Vue.use(Icon);
@Component({
  components: {
    VoteButton,
  },
})
export default class PeopleDetail extends Vue {
  item: any = {};
  async activated() {
    const res: any = await getDetail(this.$route.query.id as string);
    this.item = res.data;
  }
  votSuccess(val: any) {
    // window.location.reload();
    this.item.votes = val.num;
  }
}
